/* istanbul ignore file */
import browser, { dom } from '../../../../browser';
import expandableContent from '../../expandable-content';
import lockedContent from '../../locked-content';
import { getOcClient } from '../../../../configuration';

function parseSandbox(domContainer, sandboxLink, shouldLockSandbox) {
  const a11yId = 'code-sandbox';
  const iframeWrapper = browser.document.createElement('div');
  const iframe = browser.document.createElement('iframe');
  iframe.id = a11yId;

  iframeWrapper.classList.add('oc-code-sandbox');
  iframe.classList.add('oc-code-sandbox__iframe');

  iframe.src = sandboxLink.href;
  iframeWrapper.appendChild(iframe);

  sandboxLink.parentNode.insertBefore(iframeWrapper, sandboxLink);

  if (shouldLockSandbox) {
    lockedContent.lock.init(iframeWrapper, sandboxLink, '/login?context=courseAccess');
  } else {
    iframeWrapper.style.position = 'relative';
  }

  expandableContent.expand.init(domContainer, iframeWrapper, a11yId);

  sandboxLink.parentNode.removeChild(sandboxLink);
}

async function getCodevolveLinkWithAccessToken(originalLink) {
  const contentIdRegexp = new RegExp(/.*content_id=(.*)/);
  const contentId = originalLink && originalLink.href.match(contentIdRegexp);

  if (!contentId) {
    return null;
  }

  const { body } = await getOcClient().helpers.learningActivity.codevolve.getToken(contentId[1]);

  if (!body.accessToken) {
    return null;
  }

  return `https://www.codevolve.com/api/v1/access_token/${body.accessToken}`;
}

function init(domContainer, shouldLockSandbox) {
  const codeSandboxLinks = dom.nodeListToArray(
    domContainer.querySelectorAll('[href*="next.tech"]')
  );

  codeSandboxLinks.forEach(async (sandboxLink) => {
    const iframeLink = sandboxLink;

    if (shouldLockSandbox) {
      parseSandbox(domContainer, sandboxLink, shouldLockSandbox);
      return;
    }

    try {
      const accessTokenLink = await getCodevolveLinkWithAccessToken(sandboxLink);

      if (accessTokenLink) {
        iframeLink.href = accessTokenLink;

        parseSandbox(domContainer, iframeLink, shouldLockSandbox);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error fetching access token for Codevolve:', e);
    }
  });
}

export default {
  init,
  parseSandbox,
  getCodevolveLinkWithAccessToken,
};
